(function() { // google mapa
    if ('undefined' === typeof window.google || 'undefined' === typeof window.google.maps) {
        return;
    }

    var maps = window.google.maps;

    $('.GoogleMap').each(function(i, el) {
        var $map = $(el);

        var lat = parseFloat($map.find('.Lat').val());
        var lng = parseFloat($map.find('.Lng').val());
        var defaultLatLng = new maps.LatLng(49.819455, 15.470514);
        var zoom = parseInt($map.find('.Zoom').val(), 10);
        if (isNaN(zoom)) {
            zoom = 16;
        }
        var line = [];
        var exterior = [];
        var address = $map.find('.Address').val();
        var gmBounds = new maps.LatLngBounds().extend(new maps.LatLng(48.0, 7.0)).extend(new maps.LatLng(53.0, 22.0));

        $map.find('.line').each(function(i, el) {
            line.push(JSON.parse($(el).val()));
        });

        $map.find('.exterior').each(function(i, el) {
            exterior.push(JSON.parse($(el).val()));
        });

        var fitBounds = function(bounds, map, zoom)
        {
            map.fitBounds(bounds);

            if (typeof zoom !== "undefined" && zoom)
            {
                var zoomChangeBoundsListener = google.maps.event.addListenerOnce(map, 'bounds_changed', function(event) {
                    if (this.getZoom()) {
                        this.setZoom(zoom);
                    }
                });
                setTimeout(function(){
                    google.maps.event.removeListener(zoomChangeBoundsListener)
                }, 2000);
            }
        };

        var showMap = function(latLng, zoom) {
            if (isNaN(zoom) || 'undefined' === typeof zoom) {
                zoom = 14;
            }

            var gmMap = new maps.Map($map.get(0), {
                'zoom': zoom,
                'center': latLng,
                'mapTypeId': maps.MapTypeId.ROADMAP,
                'disableDefaultUI': true,
                'zoomControl': true,
                'zoomControlOptions': { 'style': maps.ZoomControlStyle.SMALL },
                'draggable': true,
                'scrollwheel': false,
                //'disableDoubleClickZoom': true,
                'keyboardShortcuts': false,
            });

            if (typeof window.maps_colors != 'undefined') {
                gmMap.set('styles', window.maps_colors);
            }

            var gmPolygons = [];
            $map.data('gmPolygons', gmPolygons);
            var gmMarkers = [];
            $map.data('gmMarkers', gmMarkers);
            var gmBounds = new google.maps.LatLngBounds();
            $map.data('gmBounds', gmBounds);

            if (line.length > 0)
            {
                for (var i in line)
                {

                    var gPolygon = new google.maps.Polyline({
                        path: line[i],
                        geodesic: true,
                        strokeColor: window.setting.FRONTEND_SETTING_NEMOVITOST_MAP_POLYGON_STROKE,
                        strokeOpacity: 1.0,
                        strokeWeight: 2
                    });

                    for (var j in line[i]) {
                        gmBounds.extend(new google.maps.LatLng(line[i][j]));
                    }
                    gPolygon.setMap(gmMap);
                    gmPolygons.push(gPolygon);
                }

                fitBounds(gmBounds, gmMap, zoom);
            }
            else if (exterior.length > 0)
            {
                for (var i in exterior) {

                    var gPolygon = new google.maps.Polygon({
                        paths: exterior[i],
                        strokeColor: window.setting.FRONTEND_SETTING_NEMOVITOST_MAP_POLYGON_STROKE,
                        strokeOpacity: 0.5,
                        strokeWeight: 2,
                        fillColor: window.setting.FRONTEND_SETTING_NEMOVITOST_MAP_POLYGON_FILL,
                        fillOpacity: 0.1
                    });
                    gPolygon.setMap(gmMap);
                    gmPolygons.push(gPolygon);

                    for (var j in exterior[i]) {
                        gmBounds.extend(new google.maps.LatLng(exterior[i][j]));
                    }
                }
                fitBounds(gmBounds, gmMap, zoom);
            }
            else {
                if (typeof window.maps_marker_icon != 'undefined' && typeof window.maps_marker_icon_anchor != 'undefined') {
                    window.maps_marker_icon.anchor = new maps.Point(window.maps_marker_icon_anchor[0], window.maps_marker_icon_anchor[1]);
                }

                gmMarkers.push(new maps.Marker({
                    'map': gmMap,
                    'position': latLng,
                    'icon': (typeof window.maps_marker_icon != 'undefined' ? window.maps_marker_icon : null)
                }));
                $map.data('gmZoom', zoom);
            }

            $map.data('gmMap', gmMap);
            $map.data('gmLoading', false);
        };

        if (!isNaN(lat) && !isNaN(lng)) {
            showMap(new maps.LatLng(lat, lng), zoom);
        }
        else if (line.length > 0) {
            showMap(defaultLatLng, zoom);
        }
        else if (exterior.length > 0) {
            showMap(defaultLatLng, zoom);
        }
        else if (address) {
            var gmGeocoder = new maps.Geocoder();
            $map.data('gmLoading', true);
            gmGeocoder.geocode({
                'address': address,
                'language': poskiLocale.locale
            }, function(results, status) {
                if (maps.GeocoderStatus.ZERO_RESULTS === status) {
                    return;
                }

                if (maps.GeocoderStatus.OK !== status) {
                    return;
                }

                var location;

                $.each(results, function(i, v) {
                    if (-1 === $.inArray(v.types[0], [ 'neighborhood', 'street_address', 'route', 'locality' ])) {
                        return;
                    }

                    if (!gmBounds.contains(v.geometry.location)) {
                        return;
                    }

                    showMap(v.geometry.location, zoom);
                    return false;
                });
            });
        }
    });
/*
    $('.PRMap').each(function(i, el) {
        var $el = $(el);
        var ns = $el.attr('id').replace(/^(.*)container$/, '$1');

        var $map = $el.find('#' + ns + 'map');
        (function self() {
            if ($map.data('gmLoading')) {
                setTimeout(self, 300);
                return;
            }

            var gmMap = $map.data('gmMap');
            if (null === gmMap) {
                gmMap = true;
            }
            var gmMarkers = $map.data('gmMarkers');
            if (null === gmMarkers) {
                gmMarkers = [];
            }

            $el.prMapSearch({
                'ns': ns,
                'map': gmMap,
                'markers': gmMarkers
            });
        }());
    });
*/
}());

(function() { // zvyraznovani na mapce v prehledu
    var $map = $('#Map');
    var $mapaHolder = $('#MapaHolder');
    var $ul = $('#Kraje');

    var mouseHandler = function(ev) {
        var $target = $(ev.target);
        if (!$target.is('area, a')) {
            return;
        }

        $mapaHolder.find('span').removeClass('active');
        if ('mouseover' === ev.type) {
            $mapaHolder.find('span.' + $target.attr('class').replace(/.*\b(Kraj\w+)\b.*/, '$1')).addClass('active');
        }
    };

    $map.bind('mouseover mouseout', mouseHandler);
    $ul.bind('mouseover mouseout', mouseHandler);
}());